import { useEffect } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"

import useFetch from "shared/model/useFetch"
import useConfrimCookie from "shared/model/useConfrimCookie"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const usePostAuthSnsSignup = (nameRef, nicknameRef) => {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const oauthToken = searchParams.get("oauth_token")

    const [fetchResult, fetchRequest] = useFetch()
    const [, , deleteConfirmCookie] = useConfrimCookie()
    const [, setAlert] = useAlertModalAtom()

    const clickEvent = (uploadPath) => {
        fetchRequest("POST", "/auth/signup/sns", {
            "oauth_token": oauthToken,
            "nickname": nicknameRef?.current?.value,
            "profile_img": uploadPath,
            ...(nicknameRef?.current?.value && { "name": nameRef?.current?.value })
        })
    }

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 200:
                if (fetchResult?.data?.sync) setAlert("기존에 가입된 계정이 있어 동기화 되었습니다.")
                else setAlert("회원가입이 완료되었습니다.")
                deleteConfirmCookie()
                navigate("/")
                break
            case 400:
                if (fetchResult?.data?.error_code === "name") setAlert("이름 입력 양식을 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "nickname") setAlert("닉네임 입력 양식을 확인해 주세요.")
                else setAlert("입력한 값의 형식이 잘못되었습니다.")
                break
            case 409:
                if (fetchResult?.data?.error_code === "nickname") setAlert("이미 존재하는 닉네임 입니다.")
                break
        }
    }, [fetchResult])

    return [clickEvent]
}

export default usePostAuthSnsSignup